export default __webpack_public_path__ + "static/media/nut.a97617fd.png";